/*globals $:false */

import DefinitionM from './model/recordm.model.entity.definition.js';
import DefinitionP from './presenter/recordm.presenter.definition.js';
import DefinitionV from './view/recordm.view.definition.js';

import tmpl_container from './templates/definition-container.dot';

var DefinitionCreate = function(core) {

    var _$mainContainer,
        _definitionP;

    var _init = function() {

        _$mainContainer = $(tmpl_container());
        core.translate("recordm.definition", _$mainContainer);

        _$mainContainer.appendTo('#'+core.getAppInstanceId());

        _definitionP = new DefinitionP(
            core,
            new DefinitionM(core, { name: "", description: "", state: "enabled" }),
            new DefinitionV(core, _$mainContainer)
        );
        _definitionP.init();
    };

    var _pause = function() {
        if (_definitionP) {
            _$mainContainer.detach();
        }
    };

    var _resume = function() {
        if (_definitionP) {
            _$mainContainer.appendTo('#'+core.getAppInstanceId());
        }
    };

    var _destroy = function() {
        if (_definitionP) {
            _$mainContainer.remove();
            _definitionP.destroy();
        }
    };

    return{
        init: _init,
        pause: _pause,
        resume: _resume,
        destroy: _destroy,

        getDescription: function()  {
            return {};
        }
    };
};

export default DefinitionCreate;
